<script setup>
import { __, __x, __nx } from 'JIX/gettext.js';
import DsLinkBlock from 'JIX/components/ds/DsLinkBlock.vue';
import CompanyRatingStars from 'JIX/components/CompanyRatingStars.vue';
import CompanyFollowButton from 'JIX/components/CompanyFollowButton.vue';
import CompanyLogoBox from 'JIX/components/CompanyLogoBox.vue';
import { isMedium } from 'JIX/utils';


defineProps({
    company: {
        type: Object,
        required: true,
    },
    showFollowButton: {
        type: Boolean,
        default: false,
    },
});


const emit = defineEmits(['updateFollowStatus']);

function showRating(companyData) {
    return !companyData.disableRating && companyData.ratingsCount > 0 && typeof companyData.ratingRoundedUp === 'number';
}

function handleUpdateFollowStatus(res) {
    emit('updateFollowStatus', res);
}

</script>

<template>
    <div class="card company-card">
        <div class="d-flex flex-column flex-md-row">
            <div class="mb-4 mb-md-0 gap-4 d-flex justify-content-between" v-if="company.logoUrl">
                <CompanyLogoBox
                    :logo-url="company.logoUrl"
                    :size="isMedium ? 'xl' : 'md'"
                />
                <div>
                    <CompanyFollowButton
                        class="d-md-none d-block"
                        v-if="showFollowButton"
                        :companyid="company.companyId"
                        :following="company.isFollowing"
                        @update="handleUpdateFollowStatus"
                    />
                </div>
            </div>
            <div class="d-flex flex-column w-100">
                <div
                    class="company-card-header d-flex align-items-center"
                    :data-beacon-tid="`p${company.companyId}`"
                    data-beacon-exposed="true"
                >
                    <div class="flex-grow-1 flex-column d-flex gap-2">
                        <div class="jix_company_name_link d-flex align-items-start justify-content-between gap-4">
                            <h3 class="mb-0">
                                <a
                                    :href="company.profileUrl"
                                    class="company-card-title"
                                >
                                    {{ company.companyName }}
                                </a>
                            </h3>
                            <CompanyFollowButton
                                :class="{ 'd-none d-md-block': company.logoUrl }"
                                v-if="showFollowButton"
                                :companyid="company.companyId"
                                :following="company.isFollowing"
                                @update="handleUpdateFollowStatus"
                            />
                        </div>
                        <div class="d-flex flex-column">
                            <span class="jix-rating-data" v-if="showRating(company)">
                                <a :href="company.profileEvaluationsUrl" class="d-flex align-items-center gap-1">
                                    <CompanyRatingStars
                                        size="sm"
                                        :rating="company.ratingRoundedUp"
                                    />
                                    <span>
                                        {{ __x('{ratingsCount} evalueringer', { ratingsCount: company.ratingsCount }) }}
                                    </span>
                                </a>
                            </span>
                        </div>
                    </div>
                </div>
                <span v-html="company.companyProfileHtml" />
                <DsLinkBlock :class="{'mt-0': !company.companyProfileHtml }" :href="company.jobsearchUrl">
                    {{ __nx('Se {count} job', 'Se {count} job', company.hitcount, { count: company.hitcount}) }}
                </DsLinkBlock>
            </div>
        </div>
    </div>
</template>
